import { Component, TemplateRef, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IModalData } from '../modal/simple-modal/simple-modal/simple-model-data';
import { NgTemplateOutlet } from '@angular/common';
import { MatButton } from '@angular/material/button';

export type electionConfirmationAction = 'cancel' | 'review' | 'offer' | 'offerElect';

@Component({
  selector: 'app-elect-confirmation',
  templateUrl: './elect-confirmation.component.html',
  styleUrls: ['./elect-confirmation.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgTemplateOutlet, MatButton],
})
export class ElectConfirmationComponent {
  private dialogRef = inject<MatDialogRef<ElectConfirmationComponent>>(MatDialogRef);
  public data = inject<IModalData>(MAT_DIALOG_DATA);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public template: TemplateRef<any>;

  constructor() {
    const data = this.data;

    this.template = data?.templateName;
  }

  public confirmAction(action: electionConfirmationAction): void {
    this.dialogRef.close(action);
  }
}
